import { useBucket, useExperimentVariables } from '@mc/experiments-react'
import type { Variants } from '@mc/experiments'

import { PROMO_FEATURE_FLAG } from './constants'

export const usePromotion = ({ isGift = false }: { isGift?: boolean } = {}) => {
  const promoBucket = useBucket(PROMO_FEATURE_FLAG)
  const variables = useExperimentVariables(PROMO_FEATURE_FLAG)

  const { isPromotionOn } = shouldShowPromotion({
    promoBucket,
    isGift,
    isPromoGiftEligible: !!variables.gift_eligible,
  })

  return {
    isPromotionOn,
    variables,
  }
}

// conditions to show/hide promotion
export const shouldShowPromotion = ({
  promoBucket,
  isGift = false,
  isPromoGiftEligible = false,
}: {
  promoBucket?: Variants | null
  isGift?: boolean
  isPromoGiftEligible?: boolean
}) => {
  const isPromotionOn =
    !!promoBucket?.includes('variant') && (!isGift || isPromoGiftEligible)

  return {
    isPromotionOn,
  }
}
